export default __webpack_public_path__ + "static/media/delete_small_white.f00384a3.svg";